import React from 'react';
import WebsiteImage from 'components/WebsiteImage';

import { Container } from './styles';

const FeaturedContent = ({ slideInfo: { index }, items }) => (
  <Container>
    {items?.map((item, imageIndex) => (
      <WebsiteImage
        {...item.featuredImage}
        className={`${index === imageIndex ? 'active' : 'inactive'}`}
        key={`featured-content-img-${imageIndex}`}
      />
    ))}
  </Container>
);

export default FeaturedContent;
